<template>
  <b-card
    title="مدیریت پرداخت ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="addPayment()"
              >
                جدید
              </b-button>

              <b-col md="2">
                <b-form-group
                  label="درمانگاه"
                  label-for="ClinicId"
                >
                  <z-clinic
                    v-model="filterOptions.ClinicId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group>
                  <label>نوع</label>
                  <v-select
                    v-model="filterOptions.Type"
                    :options="enums('PaymentType')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updatePayment(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Type)="data">
            <b-badge
              :variant="enums('PaymentType', 'value', data.value, 'badge')"
            >
              {{ enums('PaymentType', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(Clinic)="data">
            <b-badge
              variant="info"
            >
              {{ data.value.Title }}
            </b-badge>
          </template>

          <template #cell(Price)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Date)="data">
            {{ data.value | date }}
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link @click="updatePayment(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showPaymentModal"
      v-model="showPaymentModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="جزئیات پرداخت"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="save"
    >
      <b-row>

        <b-col md="6">
          <b-form-group
            label="درمانگاه"
            label-for="ClinicId"
          >
            <z-clinic v-model="row.ClinicId" />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="مبلغ"
            label-for="Price"
          >
            <b-input-group append="تومان">
              <cleave
                v-model="row.Price"
                class="form-control"
                :raw="false"
                :options="options"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="تاریخ"
            label-for="Date"
          >
            <date-picker
              v-model="row.Date"
              placeholder=""
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="نوع"
            label-for="Type"
          >
            <v-select
              v-model="row.Type"
              :options="enums('PaymentType')"
              dir="rtl"
              label="text"
              :reduce="x => x.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              id="Description"
              v-model="row.Description"
              name="Description"
              rows="3"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

import ZClinic from '@/tools/clinic.vue'

export default {
  name: 'Payment',
  components: { ZClinic },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        ClinicId: null,
        Page: 1,
        Type: null,
      },
      showPaymentModal: false,
      row: {},
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Clinic',
          label: 'درمانگاه',
        },
        {
          key: 'Price',
          label: 'مبلغ',
        },
        {
          key: 'Date',
          label: 'تاریخ',
        },
        {
          key: 'Type',
          label: 'نوع',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {},
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.payment.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let url = this.$api.payment.add
      if (this.row.Id) {
        url = this.$api.payment.update
      }

      const row = JSON.parse(JSON.stringify(this.row))

      if (row.Price) {
        row.Price = row.Price.replaceAll(',', '')
      }

      this.$http.post(
        url, row,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showPaymentModal = true
        })
    },
    addPayment() {
      this.row = {
        ClinicId: null, Price: null, Type: 0, Description: null, Date: this.today(),
      }
      this.showPaymentModal = true
    },
    updatePayment(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.row.ClinicId = this.row.Clinic.Id
      this.showPaymentModal = true
    },
    remove(id) {
      this.removeRow(this.$api.payment.remove, 'Id', id)
    },
    today() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
  },
}
</script>
